import styled from "styled-components";

const UIWidgetsCheckbox = styled.input.attrs({ type: "checkbox" })`
  border: 0;
`;

export default UIWidgetsCheckbox;
